import { Pipe, PipeTransform } from '@angular/core';
import { GrupoAcesso } from '../../modelos/grupo-acesso';

@Pipe({
  name: 'filtroGrupoAcesso'
})
export class FiltroGrupoAcessoPipe implements PipeTransform {

  transform(gruposAcesso: GrupoAcesso[], filtro?: string): any {
    if (gruposAcesso === undefined || filtro === undefined || filtro.trim() === '') {
      return gruposAcesso;
    }
    filtro = filtro.toLocaleLowerCase();
    return gruposAcesso.filter(grupoAcesso => grupoAcesso.nomeGrupoAcesso.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-grupo-acesso.pipe.ts